module.exports = __webpack_public_path__ + "img/haibao2@2x_new.e57e3a2b.png";